import { SHIPPING_COUNTRY_CODES, ShippingCountryCode } from "@/data/shipping-country-code"
import { CENTRA_MARKET_CODE, CentraMarketCode } from "@/data/supported-markets"

export type centraMarketToCentraArbitraryShippingCountry = Map<
    CentraMarketCode,
    ShippingCountryCode
>

const centraMarketToCentraArbitraryShippingCountry: centraMarketToCentraArbitraryShippingCountry =
    new Map<CentraMarketCode, ShippingCountryCode>([
        [CENTRA_MARKET_CODE.Eu, SHIPPING_COUNTRY_CODES.Germany],
        [CENTRA_MARKET_CODE.Na, SHIPPING_COUNTRY_CODES.USA],
        [CENTRA_MARKET_CODE.Apac, SHIPPING_COUNTRY_CODES.Australia],
        [CENTRA_MARKET_CODE.Jp, SHIPPING_COUNTRY_CODES.Japan]
    ])

export default centraMarketToCentraArbitraryShippingCountry
